type StyledText = [formattedText: string, styles: string, reset: string];
type ColorStyle = (text: string) => StyledText;

function makeColorStyle(bgColor: string, fgColor: string): ColorStyle {
  return (text: string): StyledText => {
    return [
      `%c ${text} %c`,
      `background-color: ${bgColor}; font-weight: bold; color: ${fgColor};`,
      '',
    ];
  };
}

// Fixed palette of color functions with their corresponding styles
const colorStyles: ColorStyle[] = [
  makeColorStyle('#1e90ff', 'white'), // blue
  makeColorStyle('#32cd32', 'black'), // green
  makeColorStyle('#ff00ff', 'white'), // magenta
  makeColorStyle('#00ffff', 'black'), // cyan
  makeColorStyle('#ff0000', 'white'), // red
  makeColorStyle('#ffff00', 'black'), // yellow
  makeColorStyle('#ffffff', 'black'), // white
  makeColorStyle('#404040', 'black'), // black bright
  makeColorStyle('#4169e1', 'black'), // blue bright
  makeColorStyle('#7cfc00', 'black'), // green bright
  makeColorStyle('#ff69b4', 'black'), // magenta bright
  makeColorStyle('#00ffff', 'black'), // cyan bright
  makeColorStyle('#ff4500', 'white'), // red bright
  makeColorStyle('#ffff54', 'black'), // yellow bright
];

// Hash function for consistent color assignment
function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

// Get colorized tag for prefix
function colorizePrefix(prefix: string): StyledText {
  const styleFn = colorStyles[hashString(prefix) % colorStyles.length];
  return styleFn(prefix);
}

export function createLogger(name: string) {
  const [prefixText, styles, reset] = colorizePrefix(name);
  return {
    log: (...args: any[]) => console.log(prefixText, styles, reset, ...args),
    error: (...args: any[]) =>
      console.error(prefixText, styles, reset, ...args),
    warn: (...args: any[]) => console.warn(prefixText, styles, reset, ...args),
    info: (...args: any[]) => console.info(prefixText, styles, reset, ...args),
    debug: (...args: any[]) =>
      console.debug(prefixText, styles, reset, ...args),
    trace: (...args: any[]) =>
      console.trace(prefixText, styles, reset, ...args),
  };
}
